import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelcase',
  standalone: false
})
export class CamelcasePipe implements PipeTransform {

  transform(value: string): string {
    let v = value.split(' ');


    if (v.length == 1) {
      v = value.split('_');
    }
    let result = v.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return result.join(' ');
  }

}
